import { render, staticRenderFns } from "./Instagram.vue?vue&type=template&id=a61f3bea"
import script from "./Instagram.vue?vue&type=script&lang=js"
export * from "./Instagram.vue?vue&type=script&lang=js"
import style0 from "./Instagram.vue?vue&type=style&index=0&id=a61f3bea&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports